import { ElementRef } from '@angular/core';

export abstract class SubscriptMessage {
  readonly type: 'error' | 'hint';
  readonly elementRef: ElementRef;
}
